import { render } from "./EditLogbookModal.vue?vue&type=template&id=cff486c2&scoped=true"
import script from "./EditLogbookModal.vue?vue&type=script&lang=js"
export * from "./EditLogbookModal.vue?vue&type=script&lang=js"

import "./EditLogbookModal.vue?vue&type=style&index=0&id=cff486c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff486c2"]])

export default __exports__